var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "app/views/modal/info_modal.component";
import sqlFormatter from "sql-formatter";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationsService } from "angular2-notifications";
var ReporQueriesModalComponent = /** @class */ (function (_super) {
    __extends(ReporQueriesModalComponent, _super);
    function ReporQueriesModalComponent(activeModal, notifyService) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.notifyService = notifyService;
        _this.title = 'Loading...';
        _this.queries = [];
        return _this;
    }
    ReporQueriesModalComponent.prototype.ok = function () {
        this.close();
    };
    ReporQueriesModalComponent.prototype.copyToClipboard = function (sqlQuery) {
        var el = document.createElement('textarea');
        el.value = sqlFormatter.format(sqlQuery);
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.notifyService.info('Copied!');
    };
    ;
    return ReporQueriesModalComponent;
}(InfoModalComponent));
export { ReporQueriesModalComponent };
